<div class="display-icon">
  <div class="creditcard me-3">
    <i class="fa-solid fa-credit-card"></i>
    <label class="icon-design"> {{sumCredit}} </label>
    <img src="../../../../assets/img/credit-card.png" class="creditcart">
  </div>
  <div class="money me-3">
    <i class="fa-solid fa-sack-dollar"></i>
    <img src="../../../../assets/img/money.png" class="creditcart">
    <label class="icon-design"> {{sumBalance}} </label>
  </div>
</div>